import React from "react";
var Arrow = function (_a) {
    var color = _a.color, className = _a.className;
    return (React.createElement("svg", { width: "9", height: "15", viewBox: "0 0 9 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
        React.createElement("path", { d: "M8.43104 6.31946V8.32728L2.43616 14.3246L0.568848 12.4595L5.70372 7.32458L0.568848 2.18972L2.43616 0.324585L8.43104 6.31946Z", fill: color })));
};
export default Arrow;
